import { IconMoodCry, IconSettings } from '@tabler/icons-react';
import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const ErrorContent = ({ error, type = 'common' }: { type?: string; error?: Error }) => {
  const { t } = useTranslation();

  const isPageUpgrade = useMemo(() => {
    return error?.message && error.message.includes('Failed to fetch dynamically imported module');
  }, [error]);

  useEffect(() => {
    if (isPageUpgrade) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  }, [isPageUpgrade]);

  const errorText = () => {
    return { editor: t('errors.rich_editor'), common: t('errors.common') }[type];
  };

  return (
    <div className="py-10 px-4 bg-gray-100 min-h-screen flex justify-center items-center text-gray-500">
      {isPageUpgrade ? (
        <div className="flex gap-2">
          <IconSettings className="animate-spin" />
          <div className="text-gray-400 max-w-lg whitespace-break-spaces">Page is upgrading</div>
        </div>
      ) : (
        <div>
          <div className="rounded-md flex items-center gap-3">
            <IconMoodCry className="flex-shrink-0" />
            <span>{errorText()}</span>
          </div>
          {error?.message && (
            <div className="mt-4 text-gray-400 max-w-lg whitespace-break-spaces">
              {error.name}: {error.message}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
